module.exports = __webpack_public_path__ + "img/image1.28b8e56d.jpg";